var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<connection-status></connection-status>\n<app-header></app-header>\n<div ui-view></div>\n<app-footer></app-footer>\n";
var id1="app-view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/layout/app-view.html
// module id = 2895
// module chunks = 1